import React, { useEffect, useState } from "react";
import "./LearningArticles.css"; // Import the custom CSS file for LearningArticles

const LearningArticles = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [articlesPerPage] = useState(4); // Adjust the number of articles per page as needed
  const [selectedArticle, setSelectedArticle] = useState(null); // State for selected article

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await fetch(
          "https://api.spadserver.com/api/category/learning-articles"
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setArticles(data.data.blogs.data); // Adjusted based on the JSON structure
      } catch (error) {
        setError("Failed to fetch articles");
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  const fetchArticleDetails = async (slug) => {
    try {
      const response = await fetch(`https://api.spadserver.com/api/blog/${slug}`);
      if (!response.ok) {
        throw new Error("Failed to fetch article details");
      }
      const data = await response.json();
      setSelectedArticle(data.data); // Adjusted based on the JSON structure
    } catch (error) {
      setError("Failed to load article details");
    }
  };

  // Calculate the index of the first and last article on the current page
  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = articles.slice(
    indexOfFirstArticle,
    indexOfLastArticle
  );

  const nextPage = () => {
    if (currentPage < Math.ceil(articles.length / articlesPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const previousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  if (loading)
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-500 text-xl">Loading...</p>
      </div>
    );
  if (error)
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-red-500 text-xl">{error}</p>
      </div>
    );

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6 text-center text-white bg-backgroundVector p-4 rounded-lg shadow-lg">
        مقالات آموزشی
      </h1>
      {selectedArticle ? (
        <div className="bg-gray-800 text-white p-4 border border-gray-700 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-2 text-white">{selectedArticle.title}</h2>
          {selectedArticle.photo && (
            <img
              src={`https://api.spadserver.com/storage/${selectedArticle.photo.path}`} // Updated image URL
              alt={selectedArticle.photo.title}
              className="w-full h-64 object-cover rounded-lg mb-4"
            />
          )}
          <div
            dangerouslySetInnerHTML={{ __html: selectedArticle.description }}
            className="text-gray-400 mb-4"
          />
          <button
            onClick={() => setSelectedArticle(null)}
            className="text-blue-400 hover:underline"
          >
            برگشت به مقاله ها
          </button>
        </div>
      ) : (
        <div>
          <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {currentArticles.map((article) => (
              <div
                key={article.id}
                className="bg-gray-800 text-white p-4 border border-gray-700 rounded-lg shadow-lg hover:scale-105 transition-transform duration-300"
              >
                {article.photo && (
                  <img
                    src={`https://api.spadserver.com/storage/${article.photo.path}`} // Updated image URL
                    alt={article.photo.title}
                    className="w-full h-48 object-cover rounded-t-lg mb-4"
                  />
                )}
                <h2 className="text-lg font-semibold mb-2">{article.title}</h2>
                <p className="text-gray-400 mb-4">{article.short_desc}</p>
                <button
                  onClick={() => fetchArticleDetails(article.slug)} // Updated based on new API
                  className="text-blue-400 hover:underline"
                >
                  مشاهده بیشتر
                </button>
              </div>
            ))}
          </div>
          <div className="text-center mt-8 flex justify-center space-x-4">
            <div className="w-40 flex justify-between">
              <button
                onClick={previousPage}
                className={`p-3 w-20 rounded-lg ${
                  currentPage === 1
                    ? "bg-gray-400 text-gray-700"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                }`}
                disabled={currentPage === 1}
              >
                قبلی
              </button>
              <button
                onClick={nextPage}
                className={`p-3 w-20 rounded-lg ${
                  currentPage === Math.ceil(articles.length / articlesPerPage)
                    ? "bg-gray-400 text-gray-700"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                }`}
                disabled={
                  currentPage === Math.ceil(articles.length / articlesPerPage)
                }
              >
                بعدی
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LearningArticles;
